(() => {
  const SWATCH_SELECTOR = '.hanso-compact-swatch';

  const imageUrlAtWidth = (source, width) => {
    if (!source) return '';
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return `${url.pathname}${url.search}`;
    } catch {
      return source.replace(/([?&])width=\d+/, `$1width=${width}`);
    }
  };

  const selectCardVariant = (swatch) => {
    const card = swatch.closest('product-card, .hanso-compact-card');
    if (!card) return;

    const preview = card.querySelector('.hanso-compact-image img');
    const swatchImage = swatch.querySelector('img');
    const source = swatch.dataset.variantImage || swatchImage?.getAttribute('src') || '';
    if (preview && source) {
      preview.src = imageUrlAtWidth(source, 600);
      preview.srcset = [200, 300, 450, 600]
        .map((width) => `${imageUrlAtWidth(source, width)} ${width}w`)
        .join(', ');
    }

    const variantUrl = swatch.getAttribute('href');
    if (variantUrl) {
      card
        .querySelectorAll('.product-card__link, .hanso-compact-image, .hanso-compact-title a')
        .forEach((link) => link.setAttribute('href', variantUrl));
    }

    card.querySelectorAll(SWATCH_SELECTOR).forEach((item) => {
      item.removeAttribute('aria-current');
      item.classList.remove('is-selected');
    });
    swatch.setAttribute('aria-current', 'true');
    swatch.classList.add('is-selected');
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target.closest(SWATCH_SELECTOR) : null;
      if (!(target instanceof HTMLAnchorElement)) return;
      event.preventDefault();
      event.stopPropagation();
      selectCardVariant(target);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const target = event.target instanceof Element ? event.target.closest(SWATCH_SELECTOR) : null;
      if (!(target instanceof HTMLAnchorElement)) return;
      event.preventDefault();
      event.stopPropagation();
      selectCardVariant(target);
    },
    true
  );
})();
